import { toast } from "react-toastify";

import {
  addStudentData,
  clearIndex,
  updateStudentAttendanceStaff,
} from "./attendance";
import { getAllCircular, setOffset, setPage, setPerPage } from "./circular";
import { getClasses } from "./classes";
import { getAllCourse } from "./course";
import moment from "moment";
import {
  addInterests,
  getStudentInfo,
  searchStudentAction,
  setPersonalInfo,
  setPictureUrl,
  setProfileCompleteness,
  updateStudentPersonalInfo,
} from "./student";
import { getSubject } from "./subject";
import {
  getStaffInfo,
  setStaffProfileCompleteness,
  setStaffPictureUrl,
  searchStaffAction,
} from "./staff";
import { getAllStaffNotification, getStaffNotification } from "./notification";
import { getAssignment, setRedirect } from "./assignment";
import { getNewArrival } from "./arrival";
import { setRedirection } from "./arrival";
import * as institutionStore from "./institution";
import * as configurationStore from "./configuration";
import { getStudentSubjectMarks, setRecentFiles } from "./examAndGrade";
import { getInstitution } from "./institution";

const apiMiddleware = (store) => (next) => (action) => {
  switch (action.type) {
    case "auth/login/fulfilled":
      next(action);
      const role = store.getState().auth.role;
      toast.success(`Logged in as ${role}`);
      break;
    case "student/addInterestList":
      next(action);
      const interestList = store.getState().student.interestList;
      store.dispatch(addInterests({ interestList: interestList }));
      break;
    case "student/delete/fulfilled":
      next(action);
      const abortController = new AbortController();
      let studentSearch = {
        idDepartment: "",
        idStudent: "",
        sortBy: "",
        orderBy: "asc",
        limit: 100,
        offset: 0,
        institutionId: store.getState().auth.institutionId,
      };
      store.dispatch(
        searchStudentAction({ studentSearch, signal: abortController.signal })
      );
      break;
    case "student/uploadprofile/fulfilled":
      next(action);
      if (store.getState().student.studentPersonalInfo.id) {
        store.dispatch(
          getStudentInfo({
            idStudent: store.getState().student.studentPersonalInfo.id,
          })
        );
      }
      if (store.getState().student.activeStudent) {
        store.dispatch(
          getStudentInfo({
            idStudent: store.getState().student.activeStudent,
          })
        );
      }
      store.dispatch(setPictureUrl(action.payload.ProfilePicUrl));
      break;
    // case "student/update/personal/fulfilled":
    //   next(action)
    //   const studentPersonalInfo = store.getState().student.studentPersonalInfo;
    //   store.dispatch(updateStudentPersonalInfo({ studentPersonalInfo: studentPersonalInfo }));
    //   break;
    case "staff/update/personal/fulfilled":
      next(action);
      if (store.getState().staff.staffPersonalInfo.id) {
        store.dispatch(
          getStaffInfo({
            idFaculty: store.getState().staff.staffPersonalInfo.id,
          })
        );
      }
      if (store.getState().staff.activeStaff) {
        store.dispatch(
          getStaffInfo({
            idFaculty: store.getState().staff.activeStaff,
          })
        );
      }
      break;
    case "/faculty/upload/pic/fulfilled":
      next(action);
      if (store.getState().staff.staffPersonalInfo.id) {
        store.dispatch(
          getStaffInfo({
            idFaculty: store.getState().staff.staffPersonalInfo.id,
          })
        );
      }
      if (store.getState().staff.activeStaff) {
        store.dispatch(
          getStaffInfo({
            idFaculty: store.getState().staff.activeStaff,
          })
        );
      }
      store.dispatch(setStaffPictureUrl(action.payload.ProfilePicUrl));
      break;
    case "staff/delete/fullfilled":
      next(action);
      // const abortControl = new AbortController();
      let staffSearch = {
        idDepartment: "",
        regNumber: "",
        sortBy: "asc",
        orderBy: "created_at",
        limit: 100,
        offset: 0,
        institutionId: store.getState().auth.institutionId,
      };
      store.dispatch(
        searchStaffAction({ staffSearch, signal: new AbortController().signal })
      );
      break;
    case "/delete/book/fulfilled":
      next(action);
      store.dispatch(
        getNewArrival({
          limit: 10,
          offset: 0,
          institutionId: store.getState().auth.institutionId,
        })
      );
      break;
    case "/add/book/fulfilled":
      next(action);
      store.dispatch(
        getNewArrival({
          limit: 10,
          offset: 0,
          institutionId: store.getState().auth.institutionId,
        })
      );
      break;
    case "course/addCourse/fulfilled":
      next(action);
      store.dispatch(
        getAllCourse({
          course: {
            limit: store.getState().course?.perPage,
            offSet: store.getState().course?.offset,
            institutionId: store.getState().auth.institutionId,
          },
        })
      );
      break;
    case "course/delete/fulfilled":
      next(action);
      store.dispatch(
        getAllCourse({
          course: {
            limit: store.getState().course?.perPage,
            offSet: store.getState().course?.offset,
            institutionId: store.getState().auth.institutionId,
          },
        })
      );
      break;
    case "subject/deleteSubject/fulfilled":
      next(action);
      store.dispatch(
        getSubject({
          institutionId: store.getState().auth.institutionId,
          limit: store.getState().subject?.perPage,
          offset: store.getState().subject?.offset,
        })
      );
      break;
    case "circular/delete/fulfilled":
      next(action);
      const PerPage = store.getState().circular?.perPage;
      const offSet = store.getState().circular?.offset;
      const Page = store.getState().circular?.page;

      const circularData = store.getState().circular?.data;

      if (circularData.length === 1) {
        store.dispatch(setOffset(offSet - 10));
        store.dispatch(setPage(Page - 1));
        store.dispatch(
          getAllCircular({
            limit: PerPage,
            offset: offSet,
            institutionId: store.getState().auth.institutionId,
          })
        );
      }
      store.dispatch(
        getAllCircular({
          limit: PerPage,
          offset: offSet,
          institutionId: store.getState().auth.institutionId,
        })
      );
      break;
    case "circular/add/fulfilled":
      next(action);
      const Perpage = store.getState().circular?.perPage;
      const Offset = store.getState().circular?.offset;
      store.dispatch(
        getAllCircular({
          limit: Perpage,
          offset: Offset,
          institutionId: store.getState().auth.institutionId,
        })
      );
      break;
    case "student/getStudent/fulfilled":
      next(action);
      store.dispatch(setProfileCompleteness());
      break;
    case "student/personal/fulfilled" ||
      "student/education/fulfilled" ||
      "student/contact/fulfilled" ||
      "student/achievement/fulfilled" ||
      "student/extracurricular/fulfilled" ||
      "student/interest/fulfilled":
      next(action);
      store.dispatch(setProfileCompleteness());
      break;
    case "attendance/getCurrentData":
      next(action);
      const currentIndex = store.getState().attendance.currentIndex;
      const data = store.getState().attendance.studentAttendance;
      store.dispatch(updateStudentAttendanceStaff(data[currentIndex]));
      store.dispatch(clearIndex());
      break;
    case "attendance/saveStudentAttendance/fulfilled":
      next(action);
      const lastAdded = store.getState().attendance.lastAdded;
      store.dispatch(addStudentData(lastAdded));
      break;
    case "myClass/addClasses/fulfilled" || "myClass/updateClasses/fulfilled":
      let _idFaculty = store.getState().auth.userId;
      next(action);

      store.dispatch(
        getClasses({
          fromDate: moment(moment(new Date()).startOf("isoWeek")._d).format(
            "YYYY-MM-DD"
          ),
          toDate: moment(moment(new Date()).endOf("isoWeek")._d).format(
            "YYYY-MM-DD"
          ),
          idFaculty: _idFaculty,
        })
      );
      break;
    // case "myClass/deleteClasses/fulfilled":
    //   next(action);
    //   store.dispatch(getClasses({ limit: 10, offset: 0 }));
    //   break;
    case "auth/forgot/fulfilled":
      next(action);
      toast.success(action.payload);
      break;
    case "auth/login/rejected":
      next(action);
      toast.error(action.payload);
      break;
    case "faculty/getFaculty/fulfilled":
      next(action);
      store.dispatch(setStaffProfileCompleteness());
      break;
    case "staff/addStaffInfo/fulfilled" ||
      "faculty/facultyEducationInfo/fulfilled" ||
      "faculty/employmentHistory/fulfilled" ||
      "faculty/certificate/fulfilled" ||
      "faculty/achievements/fulfilled" ||
      "faculty/interests/fulfilled":
      next(action);
      store.dispatch(setStaffProfileCompleteness());
      break;
    case "semester/add/fulfilled":
      next(action);
      store.dispatch(
        getSubject({
          institutionId: store.getState().auth.institutionId,
          limit: store.getState().subject?.perPage,
          offset: store.getState().subject?.offset,
        })
      );
      break;
    case "notification/read/fulfilled":
      next(action);
      let user = store.getState().auth.role;
      const idFaculty = store.getState().auth.userId;
      //console.log("getAllStaffNotification123", user, idFaculty);
      if (user == "Staff") {
        store.dispatch(
          getStaffNotification({
            idFaculty: idFaculty,
            limit: 10,
            offset: 0,
          })
        );
      } else {
        store.dispatch(
          getAllStaffNotification({
            limit: 10,
            offset: 0,
            institutionId: store.getState().auth.institutionId,
          })
        );
      }
      break;
    case "notification/delete/fulfilled":
      next(action);
      store.dispatch(
        getAllStaffNotification({
          limit: 10,
          offset: 0,
          institutionId: store.getState().auth.institutionId,
        })
      );
      break;
    case "notification/add/fulfilled":
      next(action);
      store.dispatch(
        getAllStaffNotification({
          limit: 10,
          offset: 0,
          institutionId: store.getState().auth.institutionId,
        })
      );
      break;
    case "student/update/personal/fulfilled":
      next(action);
      store.dispatch(
        setPersonalInfo(action.payload.params.studentPersonalInfo)
      );
      break;
    case "assignment/delete/fulfilled" ||
      "assignment/add/fulfilled" ||
      "assignment/update/fulfilled":
      next(action);
      const perPage = store.getState().assignment.perPage;
      const offset = store.getState().assignment.offset;
      store.dispatch(
        getAssignment({
          limit: perPage,
          offset: offset,
          institutionId: store.getState().auth.institutionId,
        })
      );
      break;
    case "assignment/update/fulfilled":
      next(action);
      store.dispatch(setRedirect(true));
      break;
    case "assignment/add/fulfilled":
      next(action);
      store.dispatch(setRedirect(true));
      break;
    case "/update/book/fulfilled":
      next(action);
      store.dispatch(setRedirection(true));
      break;
    case "circular/update/fulfilled":
      next(action);
      store.dispatch(
        getAllCircular({
          limit: store.getState().circular?.perPage,
          offset: store.getState().circular?.offset,
          institutionId: store.getState().auth.institutionId,
        })
      );
      break;
    case "examAndGradeSlice/uploadExamMarks/fulfilled":
      next(action);
      function stringify(obj) {
        const replacer = [];
        for (const key in obj) {
          replacer.push(key);
        }
        return JSON.stringify(obj, replacer);
      }
      store.dispatch(
        setRecentFiles(JSON.parse(stringify(action.payload.file)))
      );
      toast.success(action.payload.res);
      break;
    case "examAndGradeSlice/UpdateSubjectMarks/fulfilled":
      next(action);

      store.dispatch(
        getStudentSubjectMarks(store.getState().examAndGrade.historySearch)
      );
      break;
    case "institution/delete/fulfilled":
    case "institution/add/fulfilled":
      next(action);
      store.dispatch(
        getInstitution({
          limit: 10,
          offset: 0,
        })
      );
      break;
    case "configuration/insertFuncionalities/fulfilled":
      next(action);
      store.dispatch(
        configurationStore.getAllSuperAdminConfigurations({
          limit: 10,
          offset: 0,
          idFunctionalities: store.getState().configuration?.allfunctionalities?.data[0]?.id,
        })
      );
      break;
    case "institution/update/fulfilled":
      next(action);
      store.dispatch(institutionStore.setRedirection(true));
      break;
    default:
      next(action);
      break;
  }
};

export default apiMiddleware;
